<template>
  <v-app
    id="inspire"
    dark
  >
    <router-view class="view" />
  </v-app>
</template>

<script>

export default {
  name: 'LoginLayout'
}
</script>
